<template>
  <div v-if="isLoggedIn" class="tw-relative tw-group tw-px-4">
    <base-link
      class="tw-relative tw-z-[4]"
      :to="{
        name: USER_MOD_BROWSE_ROUTE,
        params: { user: user.name_id },
      }"
    >
      <avatar-icon :user="user" size="lg" />
    </base-link>
    <div
      class="tw-hidden group-hover:tw-block tw-fixed tw-top-8 tw-z-3 tw-pt-4 tw-right-0"
    >
      <div
        class="game-modal-background-color game-modal-text-color game-tile-radius tw-space-y-1 tw-shadow-lg tw-whitespace-nowrap"
      >
        <a
          href="https://mod.io/me/account"
          target="_blank"
          class="tw-block tw-py-2 tw-px-6 hover:game-link-color-hover"
        >
          {{ $t('account') }}
          <font-awesome-icon icon="external-link-alt" class="tw-ml-4" />
        </a>
        <button
          class="tw-block tw-w-full tw-text-left hover:game-link-color-hover tw-py-2 tw-px-6"
          @click="logout"
        >
          {{ $t('logout') }}
        </button>
      </div>
    </div>
  </div>
  <div v-else class="tw-px-4">
    <base-button
      icon-size="lg"
      icon="user"
      input-btn
      primary
      radius="full"
      @click="login"
    />
  </div>
</template>

<script>
import { USER_MOD_BROWSE_ROUTE, LIBRARY_ROUTE } from '@config/routeNames.js'
import { setGlobalModal } from '@composables/useModal.js'
import AvatarIcon from '@components/Users/AvatarIcon.vue'
import { MODAL_LOGIN } from '@config/globalModals.js'
import { logoutRequest } from '@services'
import { useRoute } from '@composables'
import { authStore } from '@stores'

export default {
  components: {
    AvatarIcon,
  },
  setup() {
    const { isLoggedIn, user } = authStore()
    const { routeName, push } = useRoute()

    function login() {
      setGlobalModal({ modal: MODAL_LOGIN })
    }

    function logout() {
      logoutRequest()
      if (routeName.value === LIBRARY_ROUTE) {
        push({ path: '/' })
      }
    }

    return {
      USER_MOD_BROWSE_ROUTE,
      isLoggedIn,
      logout,
      login,
      user,
    }
  },
}
</script>
